import {
  User,
  Home,
  GitBranch,
  Clock,
  DollarSign,
  Briefcase,
  BarChart2,
  Watch,
  Sliders,
  FileText,
} from "react-feather";

export const menuItems = [
  {
    label: "Attendance Mode",
    icon: User,
    iconColor: "#6366f1",
    iconBg: "rgba(99,102,241,0.12)",
    description: "Configure how staff mark their daily attendance",
    link: "",
    openModal: true,
    category: "Attendance",
  },
  {
    label: "Holiday",
    icon: Home,
    iconColor: "#f59e0b",
    iconBg: "rgba(245,158,11,0.12)",
    description: "Manage holiday calendar templates for your organisation",
    link: "/holidayTemplate",
    openModal: false,
    category: "Attendance",
  },
  {
    label: "Leave",
    icon: GitBranch,
    iconColor: "#f43f5e",
    iconBg: "rgba(244,63,94,0.12)",
    description: "Set up leave categories, quotas and approval rules",
    link: "/leaveTemplate",
    openModal: false,
    category: "Attendance",
  },
  {
    label: "Shift",
    icon: Clock,
    iconColor: "#10b981",
    iconBg: "rgba(16,185,129,0.12)",
    description: "Define work shifts and assign them to staff members",
    link: "/ShiftSetting",
    openModal: false,
    category: "Attendance",
  },
  {
    label: "Month Duration",
    icon: Watch,
    iconColor: "#06b6d4",
    iconBg: "rgba(6,182,212,0.12)",
    description: "Choose how monthly salary days are calculated",
    link: "",
    openModal: true,
    category: "Payroll",
  },
  {
    label: "Payroll Template",
    icon: DollarSign,
    iconColor: "#3b82f6",
    iconBg: "rgba(59,130,246,0.12)",
    description: "Define base salary structure templates for your organisation",
    link: "/payrollTemplates",
    openModal: false,
    category: "Payroll",
  },
  {
    label: "Salary Access",
    icon: DollarSign,
    iconColor: "#10b981",
    iconBg: "rgba(16,185,129,0.12)",
    description: "Control which staff can view salary information",
    link: "/SalaryDetails",
    openModal: false,
    category: "Payroll",
  },
  {
    label: "Extra Working Day",
    icon: Briefcase,
    iconColor: "#8b5cf6",
    iconBg: "rgba(139,92,246,0.12)",
    description: "Record and manage additional working days for staff",
    link: "/extra-working-day",
    openModal: false,
    category: "Payroll",
  },
  {
    label: "Overtime Policy",
    icon: Sliders,
    iconColor: "#f59e0b",
    iconBg: "rgba(245,158,11,0.12)",
    description: "Configure overtime thresholds, multipliers and approval rules",
    link: "/overtimePolicy",
    openModal: false,
    category: "Attendance",
  },
  {
    label: "Report",
    icon: BarChart2,
    iconColor: "#6366f1",
    iconBg: "rgba(99,102,241,0.12)",
    description: "Generate and download attendance and payroll reports",
    link: "/report",
    openModal: false,
    category: "Reports",
  },
  {
    label: "Letter Templates",
    icon: FileText,
    iconColor: "#6366f1",
    iconBg: "rgba(99,102,241,0.12)",
    description: "Manage default templates for Joining and Experience letters",
    link: "/letterTemplates",
    openModal: false,
    category: "Other",
  },
];
